// A tab keeps the workspace it renders even when another tab changes the session default.
const KEY = "zooi:active-workspace";
let current: string | null | undefined;
export function workspaceScope(): string | null {
  if (current !== undefined) return current;
  try { current = sessionStorage.getItem(KEY); } catch { current = null; }
  return current;
}
export function setWorkspaceScope(id: string | null) {
  current = id;
  try { if (id) sessionStorage.setItem(KEY, id); else sessionStorage.removeItem(KEY); } catch { /* The document's in-memory scope still applies. */ }
}
